import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaTrashAlt, FaCopy } from "react-icons/fa";
import shortid from "shortid";
import styled from 'styled-components';
const Container = styled.div `
	width: 100%;
`;
const TableRow = styled.div `
	display: flex;
	width: 100%;
	align-items: flex-end;
`;
const TableNumber = styled(InputBox) `
	flex: 0 0 64px;

	@media (max-width: 768px) {
		width: 100%;
	}
`;
const TableInputs = styled.div `
	display: flex;
	flex: 1;
`;
const TableInputGroup = styled(FormGroup) `
	flex: 1;
	@media (max-width: 768px) {
		display: flex;
		align-items: flex-end;
	}
	input {
		width: 100% !important;
	}
`;
const TableActions = styled.div `
	display: flex;
`;
export class FieldDineInTablesV2 extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    copy(i) {
        const values = [...this.props.values];
        const value = { ...values[i] };
        value._id = shortid.generate();
        values.push(value);
        this.props.onChange(values);
    }
    remove(i) {
        const values = [...this.props.values];
        values.splice(i, 1);
        this.props.onChange(values);
    }
    change(i, key, value) {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    }
    render() {
        const { values, baseURL, isMobile = false } = this.props;
        return (React.createElement(Container, null, values.map((item, i) => {
            let url = "";
            if (item.name && item.password) {
                url =
                    baseURL +
                        `?table_id=${item._id}&table_pw=${item.password}`;
            }
            else if (item.name) {
                url = baseURL + `?table_id=${item._id}`;
            }
            return (React.createElement(TableRow, { key: i },
                React.createElement(TableNumber, { className: "no-round text-center" },
                    React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                React.createElement(TableInputs, null,
                    React.createElement(TableInputGroup, { className: "m-b-0", title: i === 0 ? "Table Name" : null, small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", value: item.name, onChange: (e) => this.change(i, "name", e.target.value) })),
                    React.createElement(TableInputGroup, { className: "m-b-0", title: i === 0 ? "Table Password" : null, small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", value: item.password, onChange: (e) => this.change(i, "password", e.target.value) })),
                    React.createElement(TableInputGroup, { className: "m-b-0", title: i === 0 ? "Order URL" : null, small_title: true, no_border: true },
                        React.createElement(Input, { type: "text", className: "no-round", value: url, readOnly: true, onFocus: (e) => e.target.select() }))),
                React.createElement(TableActions, null,
                    React.createElement(Button, { type: "button", className: "no-round", color: "white", onClick: () => this.remove(i) },
                        React.createElement(FaTrashAlt, null)),
                    React.createElement(Button, { type: "button", className: "no-round", color: "white", onClick: () => this.copy(i) },
                        React.createElement(FaCopy, null)))));
        })));
    }
}
//# sourceMappingURL=tables-v2.js.map